module.exports = __webpack_public_path__ + "static/media/funda2.82067498.jpg";